import { UnitDisplayRecord } from "./MacroNutrient-types";
/**
 * Retrieves the display string for the given unit.
 *
 * @param {Units} [unit] - The unit for which to get the display string. Optional.
 * @returns {string} - The display string for the given unit, or an empty string if the unit is undefined or not found in UnitDisplayRecord.
 */
export const getUnitDisplay = (unit) => {
    var _a;
    if (!unit)
        return "";
    return (_a = UnitDisplayRecord[unit]) !== null && _a !== void 0 ? _a : "";
};
/**
 * Checks if the provided Nutrition object has any nutrient with a valid (greater than 0) quantity.
 *
 * @param {Nutrition} [nutrition] - The Nutrition object to check. Optional.
 * @returns {boolean} - Returns true if at least one nutrient has a quantity greater than 0, otherwise false.
 */
export const hasValidNutrientValue = (nutrition) => {
    if (!nutrition)
        return false;
    return Object.values(nutrition).some((nutrient) => (nutrient === null || nutrient === void 0 ? void 0 : nutrient.quantity) && nutrient.quantity > 0);
};
